import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as _ from 'lodash';
import { verifyTopUpOrder } from 'api/customer';
import { TOP_UP_INVOICE_STORAGE_KEY, TOP_UP_DONE_MESSAGE } from 'components/common/constant';

// Juspay returns the browser here, either inside the Add Money modal or as a full page
// when netbanking and 3DS navigate the top window
const WalletPaymentStatus = () => {
  const navigate = useNavigate();
  const verified = useRef(false);

  useEffect(() => {
    if (verified.current) {
      return;
    }
    verified.current = true;

    const framed = window.parent !== window;
    const invoiceId = sessionStorage.getItem(TOP_UP_INVOICE_STORAGE_KEY);
    sessionStorage.removeItem(TOP_UP_INVOICE_STORAGE_KEY);

    // outcome: paid | failed | cancelled | pending, decided by the gateway status
    const finish = (outcome) => {
      // Inside the modal the parent owns the toast and closing
      if (framed) {
        window.parent.postMessage({ type: TOP_UP_DONE_MESSAGE, paid: outcome === 'paid', outcome }, window.location.origin);
        return;
      }
      if (outcome === 'paid') {
        toast.success('Money added successfully');
      } else if (outcome === 'failed') {
        toast.error('Payment failed — any amount debited will be refunded automatically.');
      } else if (outcome === 'pending') {
        toast.info('Your payment is being processed');
      }
      // cancelled means the user left the gateway without paying, nothing to report
      // Nothing is refetched here, this is a fresh app boot and the dashboard loads its own data
      navigate('/dashboard', { replace: true });
    };

    // No invoice in this tab means the page was opened directly, not returned to
    if (!invoiceId) {
      finish('cancelled');
      return;
    }
    verifyTopUpOrder(invoiceId, {})
      .then((res) => finish(_.get(res, 'data.paid', false) ? 'paid' : _.get(res, 'data.outcome', 'pending')))
      .catch(() => finish('failed'));
  }, [navigate]);

  return <div className="page-loader">Verifying your payment...</div>;
};

export default WalletPaymentStatus;
